export default class PartnerCreateRequest {
    constructor(locale, supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                description: '',
            };
        });
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
        } else {
            to = new PartnerCreateRequest();
        }
    }

    static copy(from) {
        const to = new PartnerCreateRequest();
        PartnerCreateRequest.assign(from, to);
        return to;
    }
}
